export default "__VITE_ASSET__38cce073__"